import Vue from 'vue'
import Vuex from 'vuex'
import { authModule } from './auth/AuthStore'
import { companyListModule } from './company-list/CompanyListStore'
import { orderModule } from './order/OrderStore'
import { productModule } from './product/ProductStore'
import { dialogModule } from './components/dialog/DialogStore'
import { systemModule } from './system/SystemStore'
import { regionModule } from './region/RegionStore'
import { companyModule } from './company/CompanyStore'

Vue.use(Vuex)

const pspPix = process.env.VUE_APP_PSP_PIX || 'banco_brasil'

const viewContext =
  localStorage.getItem('viewContext') ||
  process.env.VUE_APP_INIT_VIEWCONTEXT ||
  'companyList'

export default new Vuex.Store({
  state: {
    pspPix: pspPix,
    viewContext: viewContext,
    snackbar: {
      show: false,
      variant: null,
      message: null,
    },
  },
  mutations: {
    updateViewContext(state, setting) {
      state.viewContext = setting
      localStorage.setItem('viewContext', setting)
    },
    updateSnackbar(state, settings) {
      state.snackbar = {
        show: settings.show,
        variant: settings.variant ?? null,
        message: settings.message || '',
        duration: settings.duration || 3000,
      }
    },
  },
  actions: {
    updateSnackbar({ commit }, payload) {
      commit('updateSnackbar', payload)
    },
    updateViewContext({ commit }, payload) {
      commit('updateViewContext', payload)
    },
  },
  modules: {
    authModule,
    companyListModule,
    productModule,
    orderModule,
    dialogModule,
    systemModule,
    regionModule,
    companyModule,
  },
})
